// İlçe landing page verileri — SEO optimizasyonu için
// Her ilçe benzersiz içerik, SSS ve metadata içerir

export const DISTRICT_PAGES = [
  {
    id: 1,
    slug: 'gebze-lastik-yol-yardim',
    name: 'Gebze',
    displayName: 'Gebze',
    mobileId: '1',
    title: 'Gebze Lastik Yol Yardım | 7/24 Acil Mobil Lastikçi Gebze',
    metaDesc: 'Gebze lastik yol yardım hizmeti. 7/24 acil lastik tamiri, değişimi ve mobil lastikçi. Gebze, Çayırova, Darıca bölgesine ortalama 25 dakikada ulaşıyoruz.',
    h1: 'Gebze Lastik Yol Yardım',
    h1Accent: '7/24 Acil Mobil Lastikçi',
    intro: 'Gebze ve çevre bölgelerinde lastiğiniz patladı, sibobunuz arızalandı ya da stepneniz yok mu? 7/24 Lastik olarak Gebze ilçesinin her noktasına ortalama 25 dakikada ulaşıyoruz. TEM Otoyolu, D-100 Karayolu ve Gebze sanayi bölgesi dahil tüm alanlarda mobil lastik yol yardım hizmeti sunuyoruz.',
    content: `<h2>Gebze'de Lastik Yol Yardım Hizmeti</h2>
<p><strong>Gebze lastik yol yardım</strong> hizmeti, Kocaeli'nin en kalabalık ilçesi olan Gebze'de yolda kalan sürücülere 7/24 kesintisiz destek sağlar. Özellikle <strong>TEM Otoyolu</strong>, <strong>D-100 Karayolu</strong> ve Gebze sanayi bölgeleri gibi yoğun trafik noktalarında lastik patlağı ve arıza durumlarına anında müdahale ediyoruz.</p>

<h3>Gebze'de Hangi Hizmetleri Sunuyoruz?</h3>
<ul>
<li>Acil lastik tamiri (yerinde)</li>
<li>Lastik değişimi ve montajı</li>
<li>Sibop tamiri ve değişimi</li>
<li>Stepne montajı</li>
<li>Jant onarımı</li>
<li>Lastik hava basma</li>
<li>Kış zinciri takma</li>
</ul>

<h3>Gebze Bölgesinde Hizmet Verdiklerimiz</h3>
<p>Gebze merkez, Güzeltepe, Atatürk Mahallesi, Beylikbağı, Darıcı Yolu, Pelitli, Mollafenari, GOSB, Gebze Organize Sanayi Bölgesi ve çevre tüm mahallelere mobil aracımızla hizmet veriyoruz.</p>

<p>Gebze'nin stratejik konumu nedeniyle İstanbul-Kocaeli geçiş güzergahındaki sürücülere de hızlı müdahale sağlıyoruz. Otoyolda kalsanız bile, ekibimiz en yakın çıkıştan ulaşır.</p>`,
    faqs: [
      { q: 'Gebze\'de lastik yol yardım ne kadar sürede gelir?', a: 'Gebze merkezine ortalama 20-25 dakikada, çevre mahallelere 30 dakika içinde ulaşıyoruz.' },
      { q: 'Gebze\'de gece lastik tamiri yapılıyor mu?', a: 'Evet, 7/24 hizmet veriyoruz. Gece 03:00\'te bile arayın, ekibimiz yola çıkar.' },
      { q: 'Gebze GOSB bölgesine lastik yol yardım geliyor mu?', a: 'Evet, Gebze Organize Sanayi Bölgesi (GOSB) dahil tüm sanayi bölgelerine hizmet veriyoruz.' },
      { q: 'Gebze\'de kamyon lastik tamiri yapılıyor mu?', a: 'Evet, binek araçtan kamyona, otobüsten traktöre kadar tüm araç tiplerine hizmet veriyoruz.' },
    ],
    nearbyDistricts: ['darica-lastik-yol-yardim', 'cayirova-lastik-yol-yardim', 'dilovasi-lastik-yol-yardim'],
    nearbyNames: ['Darıca', 'Çayırova', 'Dilovası'],
  },
  {
    id: 2,
    slug: 'izmit-lastik-yol-yardim',
    name: 'İzmit',
    displayName: 'İzmit',
    mobileId: '2',
    title: 'İzmit Lastik Yol Yardım | 7/24 Acil Mobil Lastikçi İzmit',
    metaDesc: 'İzmit lastik yol yardım hizmeti. 7/24 acil lastik tamiri ve değişimi. İzmit merkez, Yahyakaptan, Cedit ve tüm mahallelere ortalama 20 dakikada ulaşıyoruz.',
    h1: 'İzmit Lastik Yol Yardım',
    h1Accent: '7/24 Acil Müdahale',
    intro: 'İzmit, Kocaeli\'nin kalbi. Şehir merkezinden TEM Otoyolu\'na, Yahyakaptan\'dan Cedit\'e kadar her noktada 7/24 lastik yol yardım hizmeti sunuyoruz. Lastiğiniz patlasa bile sakin kalın — ortalama 20 dakikada yanınızdayız.',
    content: `<h2>İzmit'te 7/24 Lastik Yol Yardım</h2>
<p><strong>İzmit lastik yol yardım</strong> hizmetimiz, Kocaeli'nin merkez ilçesinde sürücülere profesyonel destek sağlar. <strong>İzmit merkez</strong>, <strong>Yahyakaptan</strong>, <strong>Cedit</strong>, <strong>Yenişehir</strong> ve <strong>Kozluk</strong> gibi yoğun yerleşimlerde lastik arızalarına hızla müdahale ediyoruz.</p>

<h3>İzmit'te Neden 7/24 Lastik?</h3>
<ul>
<li>İzmit merkezine ortalama 15-20 dakika müdahale süresi</li>
<li>TEM ve D-100 üzerinde hızlı erişim</li>
<li>Körfez Köprüsü geçişinde destek</li>
<li>7/24 kesintisiz hizmet, bayram ve tatil dahil</li>
</ul>

<h3>İzmit Hizmet Bölgeleri</h3>
<p>İzmit merkezin tüm mahalleleri: Yenidoğan, Yeşiltepe, Orhan, 28 Haziran, Tepecik, Gültepe, Yeniköy, Durhasan ve daha fazlası. Sanayi alanları, hastane çevresi ve alışveriş merkezleri dahil her noktaya ulaşıyoruz.</p>`,
    faqs: [
      { q: 'İzmit merkezde lastik tamiri ne kadar sürer?', a: 'Basit bir lastik tamiri ortalama 15-20 dakikada tamamlanır. Lastik değişimi biraz daha uzun sürebilir.' },
      { q: 'İzmit\'te en yakın lastikçi nerede?', a: '7/24 Lastik olarak İzmit\'in her noktasına mobil aracımızla geliyoruz. Sabit bir adrese gitmenize gerek yok.' },
      { q: 'İzmit\'te gece lastikçi var mı?', a: 'Evet, gece gündüz fark etmez. 7/24 Lastik ekibi İzmit genelinde her saat aktiftir.' },
      { q: 'İzmit otoyolda lastik patladı ne yapmalıyım?', a: 'Güvenli bir şekilde sağınıza çekin, dörtlü flaşörleri yakın ve bizi arayın. Ekibimiz otoyola da gelir.' },
    ],
    nearbyDistricts: ['derince-lastik-yol-yardim', 'basiskele-lastik-yol-yardim', 'korfez-lastik-yol-yardim'],
    nearbyNames: ['Derince', 'Başiskele', 'Körfez'],
  },
  {
    id: 3,
    slug: 'darica-lastik-yol-yardim',
    name: 'Darıca',
    displayName: 'Darıca',
    mobileId: '3',
    title: 'Darıca Lastik Yol Yardım | 7/24 Acil Mobil Lastikçi',
    metaDesc: 'Darıca lastik yol yardım. 7/24 acil lastik tamiri ve değişimi. Darıca sahil yolu, merkez ve tüm mahallelere hızlı müdahale.',
    h1: 'Darıca Lastik Yol Yardım',
    h1Accent: 'Hızlı ve Güvenilir',
    intro: 'Darıca\'da lastiğiniz mi patladı? Endişelenmeyin! 7/24 Lastik güvenilir ve tecrübeli personeliyle Darıca\'nın her noktasına en kısa sürede ulaşır. Sahil yolundan sanayi bölgesine kadar tüm Darıca genelinde mobil lastik yol yardım hizmeti.',
    content: `<h2>Darıca'da Lastik Yol Yardım</h2>
<p><strong>Darıca lastik yol yardım</strong> hizmetimiz ile Darıca ilçesinde yolda kalan sürücülere anında destek sağlıyoruz. <strong>Darıca sahil yolu</strong>, <strong>Osmangazi Mahallesi</strong>, <strong>Bağlarıçı</strong> ve çevre tüm bölgeler kapsama alanındadır.</p>

<h3>Darıca Bölgesinde Sunduğumuz Hizmetler</h3>
<ul>
<li>Acil lastik tamiri ve yaması</li>
<li>Yeni lastik montajı (yerinde)</li>
<li>Sibop değişimi</li>
<li>Stepne takma hizmeti</li>
<li>Hava basma ve basınç ayarı</li>
</ul>

<p>Darıca, Gebze ve İstanbul sınırında stratejik bir konumdadır. Bu nedenle yoğun trafik ve otoyol geçişlerinde lastik arızaları sık yaşanır. Ekibimiz bu bölgeye özel konumlanmıştır.</p>`,
    faqs: [
      { q: 'Darıca\'da 7/24 lastikçi var mı?', a: 'Evet, 7/24 Lastik olarak Darıca\'da gece gündüz hizmet veriyoruz.' },
      { q: 'Darıca sahil yolunda lastik patladı ne yapmalıyım?', a: 'Güvenli bir noktaya çekin ve bizi arayın. Ekibimiz sahil yoluna da gelir.' },
      { q: 'Darıca\'dan Gebze\'ye giderken lastik patladı, hizmet verir misiniz?', a: 'Evet, Darıca-Gebze güzergahı tamamen kapsama alanımızdadır.' },
    ],
    nearbyDistricts: ['gebze-lastik-yol-yardim', 'cayirova-lastik-yol-yardim', 'dilovasi-lastik-yol-yardim'],
    nearbyNames: ['Gebze', 'Çayırova', 'Dilovası'],
  },
  {
    id: 4,
    slug: 'korfez-lastik-yol-yardim',
    name: 'Körfez',
    displayName: 'Körfez',
    mobileId: '4',
    title: 'Körfez Lastik Yol Yardım | 7/24 Acil Lastik Tamiri Körfez',
    metaDesc: 'Körfez lastik yol yardım hizmeti. 7/24 acil lastik tamiri ve mobil lastikçi. Körfez, Yarımca, Hereke bölgesine hızlı müdahale.',
    h1: 'Körfez Lastik Yol Yardım',
    h1Accent: '7/24 Profesyonel Destek',
    intro: 'Körfez ilçesinde yoldasınız ve lastiğinizde sorun mu var? 7/24 Lastik olarak Körfez\'in her noktasına — Yarımca, merkez ve sanayi bölgelerine hızla ulaşıyoruz. Profesyonel ekibimiz yerinde müdahale eder.',
    content: `<h2>Körfez'de Acil Lastik Yol Yardım</h2>
<p><strong>Körfez lastik yol yardım</strong> hizmetimiz, özellikle <strong>Yarımca</strong>, <strong>Körfez merkez</strong> ve çevre sanayi bölgelerindeki sürücülere 7/24 destek sağlar. Petrokimya bölgesi ve rafineriler civarı dahil tüm Körfez genelinde mobil lastik servisi sunuyoruz.</p>

<h3>Körfez'de Neden Bizi Seçmelisiniz?</h3>
<ul>
<li>Körfez bölgesine ortalama 25 dakika müdahale</li>
<li>Ağır vasıta ve ticari araç lastik tamiri</li>
<li>Sanayi bölgesi içinde hizmet imkanı</li>
<li>Tüm lastik marka ve modelleri için çözüm</li>
</ul>`,
    faqs: [
      { q: 'Körfez\'de lastik tamiri ne kadar?', a: 'Fiyat yapılacak işleme göre değişir. Arayın, telefonla net fiyat bilgisi verelim.' },
      { q: 'Körfez Yarımca bölgesine lastik yol yardım geliyor mu?', a: 'Evet, Yarımca dahil tüm Körfez ilçesine hizmet veriyoruz.' },
      { q: 'Körfez\'de TIR lastik tamiri yapılıyor mu?', a: 'Evet, kamyon ve TIR lastiklerine de yerinde tamir ve değişim hizmeti sunuyoruz.' },
    ],
    nearbyDistricts: ['izmit-lastik-yol-yardim', 'derince-lastik-yol-yardim', 'hereke-lastik-yol-yardim'],
    nearbyNames: ['İzmit', 'Derince', 'Hereke'],
  },
  {
    id: 5,
    slug: 'golcuk-lastik-yol-yardim',
    name: 'Gölcük',
    displayName: 'Gölcük',
    mobileId: '5',
    title: 'Gölcük Lastik Yol Yardım | 7/24 Acil Lastik Servisi Gölcük',
    metaDesc: 'Gölcük lastik yol yardım. 7/24 acil lastik tamiri, değişimi. Gölcük merkez, Yazlık, Halıderefelı bölgesine mobil lastik servisi.',
    h1: 'Gölcük Lastik Yol Yardım',
    h1Accent: '7/24 Yanınızdayız',
    intro: 'Gölcük\'te acil lastik sorununuzun giderilmesi mi gerekiyor? Hiç zaman kaybetmeden yolunuza devam etmeniz için alanında uzman ekibimizle 7/24 hizmetinizdeyiz. Gölcük merkez, sahil bölgesi ve dağ yollarında bile yanınızdayız.',
    content: `<h2>Gölcük'te Lastik Yol Yardım Hizmeti</h2>
<p><strong>Gölcük lastik yol yardım</strong> ekibimiz, Gölcük ilçesinin tüm bölgelerine 7/24 kesintisiz hizmet sunar. <strong>Gölcük merkez</strong>, <strong>Yazlık</strong>, <strong>Ulaşlı</strong> ve sahil şeridi boyunca lastik arızalarına anında müdahale ederiz.</p>

<h3>Gölcük'te Sunduğumuz Hizmetler</h3>
<ul>
<li>Acil lastik tamiri</li>
<li>Lastik değişimi ve montajı</li>
<li>Kış lastiği takma/çıkarma</li>
<li>Zincir takma hizmeti</li>
<li>Hava basınç kontrolü</li>
</ul>

<p>Gölcük, özellikle kış aylarında dağ geçişleri ve kaygan yollar nedeniyle lastik arızalarının sık yaşandığı bir bölgedir. Ekibimiz bu koşullara hazır olarak hizmet verir.</p>`,
    faqs: [
      { q: 'Gölcük\'te gece lastik yol yardım var mı?', a: 'Evet, 7/24 kesintisiz hizmet veriyoruz. Gece yarısı bile arayın, geliyoruz.' },
      { q: 'Gölcük sahil yolunda lastik değişimi yapılıyor mu?', a: 'Evet, sahil yolu dahil tüm Gölcük bölgelerine mobil aracımızla geliyoruz.' },
      { q: 'Gölcük\'te kış lastiği takma hizmeti var mı?', a: 'Evet, kış lastiği takma ve çıkarma hizmetimiz mevcuttur. Yerinize geliyoruz.' },
    ],
    nearbyDistricts: ['izmit-lastik-yol-yardim', 'basiskele-lastik-yol-yardim', 'karamursel-lastik-yol-yardim'],
    nearbyNames: ['İzmit', 'Başiskele', 'Karamürsel'],
  },
  {
    id: 6,
    slug: 'derince-lastik-yol-yardim',
    name: 'Derince',
    displayName: 'Derince',
    mobileId: '6',
    title: 'Derince Lastik Yol Yardım | 7/24 Mobil Lastik Servisi',
    metaDesc: 'Derince lastik yol yardım. 7/24 acil lastik tamiri ve değişimi. Derince merkez, liman bölgesi ve çevre mahallelere hızlı müdahale.',
    h1: 'Derince Lastik Yol Yardım',
    h1Accent: 'Bir Telefon Kadar Yakın',
    intro: 'Derince\'de acil lastik yardımı hizmeti veren bir firma arıyorsanız, endişelenmeyin! 7/24 Lastik olarak bir telefon kadar yakınızdayız. Derince liman bölgesi, merkez ve tüm mahallelere mobil lastik yol yardım hizmeti sunuyoruz.',
    content: `<h2>Derince'de 7/24 Lastik Yol Yardım</h2>
<p><strong>Derince lastik yol yardım</strong> hizmetimiz, <strong>Derince Limanı</strong> çevresi, merkez mahalleler ve sanayi bölgelerine 7/24 destek sağlar. Özellikle liman trafiği ve ağır vasıta yoğunluğu nedeniyle Derince'de lastik arızaları sık yaşanır.</p>

<h3>Derince Hizmet Detayları</h3>
<ul>
<li>Liman bölgesi dahil tüm Derince genelinde hizmet</li>
<li>Ağır vasıta ve TIR lastik değişimi</li>
<li>Yerinde lastik tamiri ve yaması</li>
<li>Acil müdahale süresi: ortalama 20 dakika</li>
</ul>`,
    faqs: [
      { q: 'Derince liman bölgesine lastik servisi geliyor mu?', a: 'Evet, Derince Limanı çevresi dahil tüm bölgelerimize hizmet veriyoruz.' },
      { q: 'Derince\'de lastik değiştirme ücreti ne kadar?', a: 'Ücretler lastik markası ve araç tipine göre değişir. Arayın, telefonla bilgi alalım.' },
      { q: 'Derince\'de hafta sonu lastikçi açık mı?', a: 'Evet, 7 gün 24 saat hizmet veriyoruz. Hafta sonu, bayram farketmez.' },
    ],
    nearbyDistricts: ['izmit-lastik-yol-yardim', 'korfez-lastik-yol-yardim', 'golcuk-lastik-yol-yardim'],
    nearbyNames: ['İzmit', 'Körfez', 'Gölcük'],
  },
  {
    id: 7,
    slug: 'cayirova-lastik-yol-yardim',
    name: 'Çayırova',
    displayName: 'Çayırova',
    mobileId: '7',
    title: 'Çayırova Lastik Yol Yardım | 7/24 Acil Lastik Tamiri',
    metaDesc: 'Çayırova lastik yol yardım hizmeti. 7/24 acil lastik tamiri ve değişimi. Çayırova sanayi bölgesi ve tüm mahallelere mobil lastikçi.',
    h1: 'Çayırova Lastik Yol Yardım',
    h1Accent: '7/24 Acil Destek',
    intro: 'Çayırova\'da arabanız ile yolda giderken aniden bir sesle seyahatiniz yarım kalabilir. Bu durum sizi endişelendirebilir ancak panik yapmanıza gerek yok. 7/24 Lastik ekibi Çayırova\'nın her noktasına hızla ulaşır.',
    content: `<h2>Çayırova'da Lastik Yol Yardım</h2>
<p><strong>Çayırova lastik yol yardım</strong> hizmetimiz ile sanayi bölgeleri, konut alanları ve ana arter yollar dahil tüm Çayırova genelinde 7/24 destek sağlıyoruz.</p>

<h3>Çayırova'da Hizmet Bölgelerimiz</h3>
<ul>
<li>Çayırova sanayi bölgesi</li>
<li>Çayırova merkez mahalleler</li>
<li>TEM Otoyolu Çayırova kavşakları</li>
<li>Gebze-Çayırova güzergahı</li>
</ul>

<p>Çayırova, sanayi bölgeleri nedeniyle ağır vasıta trafiğinin yoğun olduğu bir ilçedir. Ekibimiz hem binek hem ticari araç lastiklerine hizmet verir.</p>`,
    faqs: [
      { q: 'Çayırova sanayi bölgesine lastik yol yardım gelir mi?', a: 'Evet, Çayırova sanayi bölgesi dahil tüm bölgelerimize 7/24 hizmet veriyoruz.' },
      { q: 'Çayırova\'da mobil lastik tamiri yapılıyor mu?', a: 'Evet, mobil aracımızla yerinize gelip lastik tamirinizi yerinde yapıyoruz.' },
      { q: 'Çayırova\'da lastik fiyatları nedir?', a: 'Lastik fiyatları marka ve modele göre değişir. Arayın, size en uygun seçeneği sunalım.' },
    ],
    nearbyDistricts: ['gebze-lastik-yol-yardim', 'darica-lastik-yol-yardim', 'dilovasi-lastik-yol-yardim'],
    nearbyNames: ['Gebze', 'Darıca', 'Dilovası'],
  },
  {
    id: 8,
    slug: 'kartepe-lastik-yol-yardim',
    name: 'Kartepe',
    displayName: 'Kartepe',
    mobileId: '8',
    title: 'Kartepe Lastik Yol Yardım | 7/24 Acil Lastik Servisi',
    metaDesc: 'Kartepe lastik yol yardım. 7/24 acil lastik tamiri, kış lastiği ve zincir takma. Kartepe dağ yolu ve merkeze hızlı müdahale.',
    h1: 'Kartepe Lastik Yol Yardım',
    h1Accent: 'Dağ Yolunda Bile Yanınızdayız',
    intro: 'Kartepe\'ye tatile mi çıkacaksınız veya dağ yolunda mı kaldınız? Maalesef lastiğinize çivi mi batmış? 7/24 Lastik olarak Kartepe dağ yollarında, kayak merkezi güzergahında ve merkez mahallelerde lastik yol yardım hizmeti veriyoruz.',
    content: `<h2>Kartepe'de Lastik Yol Yardım</h2>
<p><strong>Kartepe lastik yol yardım</strong> hizmetimiz, özellikle <strong>dağ yolları</strong>, <strong>kayak merkezi güzergahı</strong> ve <strong>Kartepe merkez</strong> bölgelerinde sürücülere 7/24 destek sağlar. Kış aylarında zincir takma ve kış lastiği değişimi en sık talep edilen hizmetlerimiz arasındadır.</p>

<h3>Kartepe Özel Hizmetler</h3>
<ul>
<li>Dağ yollarında acil lastik tamiri</li>
<li>Kış lastiği takma ve çıkarma</li>
<li>Zincir takma hizmeti</li>
<li>Kayak merkezi güzergahında destek</li>
<li>Buzlanma ve kaygan zeminlerde yardım</li>
</ul>`,
    faqs: [
      { q: 'Kartepe dağ yolunda lastik patladı ne yapmalıyım?', a: 'Güvenli bir noktaya çekin ve bizi arayın. Dağ yollarına da ekibimiz geliyor.' },
      { q: 'Kartepe\'de zincir takma hizmeti var mı?', a: 'Evet, kış aylarında Kartepe dağ yollarında zincir takma hizmeti veriyoruz.' },
      { q: 'Kartepe kayak merkezine giderken lastik yol yardım alabilir miyim?', a: 'Evet, kayak merkezi güzergahı dahil tüm Kartepe bölgelerine hizmet veriyoruz.' },
    ],
    nearbyDistricts: ['izmit-lastik-yol-yardim', 'basiskele-lastik-yol-yardim', 'golcuk-lastik-yol-yardim'],
    nearbyNames: ['İzmit', 'Başiskele', 'Gölcük'],
  },
  {
    id: 9,
    slug: 'basiskele-lastik-yol-yardim',
    name: 'Başiskele',
    displayName: 'Başiskele',
    mobileId: '9',
    title: 'Başiskele Lastik Yol Yardım | 7/24 Acil Mobil Lastikçi',
    metaDesc: 'Başiskele lastik yol yardım hizmeti. 7/24 acil lastik tamiri ve değişimi. Başiskele, Yuvacık ve çevre mahallelere hızlı müdahale.',
    h1: 'Başiskele Lastik Yol Yardım',
    h1Accent: '7/24 Hizmetinizdeyiz',
    intro: 'Saatlerce lastik hizmeti veren firma aramanıza gerek kalmadı. 7/24 Lastik olarak Başiskele\'nin her noktasında — Yuvacık, merkez ve sahil kesiminde — profesyonel lastik yol yardım hizmeti sunuyoruz.',
    content: `<h2>Başiskele'de Lastik Yol Yardım</h2>
<p><strong>Başiskele lastik yol yardım</strong> hizmetimiz ile <strong>Yuvacık</strong>, <strong>Başiskele merkez</strong>, <strong>Kullar</strong> ve çevre tüm mahallelere 7/24 mobil lastik servisi sağlıyoruz.</p>

<h3>Başiskele Hizmet Avantajları</h3>
<ul>
<li>Başiskele merkezine ortalama 20 dakika müdahale</li>
<li>Yuvacık bölgesi dahil kapsama</li>
<li>Tüm lastik marka ve çeşitlerine hizmet</li>
<li>Yerinde profesyonel tamir</li>
</ul>`,
    faqs: [
      { q: 'Başiskele\'de en yakın lastikçi nerede?', a: '7/24 Lastik mobil aracımız Başiskele\'nin her noktasına gelir. Sabit adres aramanıza gerek yok.' },
      { q: 'Başiskele Yuvacık\'a lastik servisi geliyor mu?', a: 'Evet, Yuvacık dahil tüm Başiskele bölgelerine hizmet veriyoruz.' },
      { q: 'Başiskele\'de lastik değişim ücreti ne kadar?', a: 'Lastik tipine ve markasına göre değişir. Arayın, anında fiyat bilgisi verelim.' },
    ],
    nearbyDistricts: ['izmit-lastik-yol-yardim', 'golcuk-lastik-yol-yardim', 'kartepe-lastik-yol-yardim'],
    nearbyNames: ['İzmit', 'Gölcük', 'Kartepe'],
  },
  {
    id: 10,
    slug: 'karamursel-lastik-yol-yardim',
    name: 'Karamürsel',
    displayName: 'Karamürsel',
    mobileId: '10',
    title: 'Karamürsel Lastik Yol Yardım | 7/24 Acil Lastik Servisi',
    metaDesc: 'Karamürsel lastik yol yardım. 7/24 acil lastik tamiri ve değişimi. Karamürsel merkez ve çevre köylere mobil lastik servisi.',
    h1: 'Karamürsel Lastik Yol Yardım',
    h1Accent: '7/24 Mobil Servis',
    intro: 'Karamürsel\'de lastik patlağı, sibop arızası, yeni lastik veya jant değişimi sorunlarınıza 7/24 çözüm sunuyoruz. Karamürsel merkez ve çevre köylere mobil aracımızla hizmet veriyoruz.',
    content: `<h2>Karamürsel'de Lastik Yol Yardım</h2>
<p><strong>Karamürsel lastik yol yardım</strong> hizmetimiz ile bu güzel sahil ilçesinde yolda kalan sürücülere 7/24 destek sağlıyoruz. <strong>Karamürsel merkez</strong>, sahil yolu ve çevre köylere mobil lastik servisi sunuyoruz.</p>

<h3>Karamürsel'de Hizmet Kapsamımız</h3>
<ul>
<li>Karamürsel merkez ve mahalleler</li>
<li>Sahil yolu boyunca servis</li>
<li>Çevre köy ve beldeler</li>
<li>Yalova-Kocaeli güzergahı</li>
</ul>`,
    faqs: [
      { q: 'Karamürsel\'e lastik yol yardım geliyor mu?', a: 'Evet, Karamürsel merkez ve çevre köylere 7/24 lastik yol yardım hizmeti veriyoruz.' },
      { q: 'Karamürsel\'de hangi lastik markaları bulunur?', a: 'Goodyear, Michelin, Bridgestone, Lassa, Pirelli gibi tüm büyük markaları temin edebiliriz.' },
      { q: 'Karamürsel sahil yolunda lastik tamiri yapılır mı?', a: 'Evet, sahil yolu dahil tüm Karamürsel bölgelerine mobil aracımızla geliyoruz.' },
    ],
    nearbyDistricts: ['golcuk-lastik-yol-yardim', 'basiskele-lastik-yol-yardim', 'kandira-lastik-yol-yardim'],
    nearbyNames: ['Gölcük', 'Başiskele', 'Kandıra'],
  },
  {
    id: 11,
    slug: 'kandira-lastik-yol-yardim',
    name: 'Kandıra',
    displayName: 'Kandıra',
    mobileId: '11',
    title: 'Kandıra Lastik Yol Yardım | 7/24 Acil Lastikçi Kandıra',
    metaDesc: 'Kandıra lastik yol yardım hizmeti. 7/24 acil lastik tamiri. Kandıra merkez, sahil ve tatil bölgelerine mobil lastik servisi.',
    h1: 'Kandıra Lastik Yol Yardım',
    h1Accent: 'Tatilde de Yanınızdayız',
    intro: 'Kandıra\'da tatile mi gidiyorsunuz? Lastiklerinizden kaynaklı bir arızadan dolayı yola devam edemiyorsanız bizi arayın. 7/24 Lastik olarak Kandıra merkez, sahil ve tatil bölgelerine mobil lastik servisi sunuyoruz.',
    content: `<h2>Kandıra'da Lastik Yol Yardım</h2>
<p><strong>Kandıra lastik yol yardım</strong> hizmetimiz, özellikle yaz aylarında tatil bölgeleri ve sahil kenarındaki sürücülere büyük kolaylık sağlar. <strong>Kandıra merkez</strong>, <strong>Babalı plajı</strong>, <strong>Cebeci</strong> ve çevre köylere 7/24 hizmet veriyoruz.</p>

<h3>Kandıra Özel Durumlar</h3>
<ul>
<li>Tatil bölgelerinde acil lastik tamiri</li>
<li>Köy yollarında mobil servis</li>
<li>Sahil güzergahında destek</li>
<li>Orman yollarında lastik değişimi</li>
</ul>`,
    faqs: [
      { q: 'Kandıra\'da lastik yol yardım var mı?', a: 'Evet, 7/24 Lastik olarak Kandıra genelinde mobil lastik yol yardım hizmeti veriyoruz.' },
      { q: 'Kandıra sahiline lastik servisi gelir mi?', a: 'Evet, Kandıra sahil bölgeleri dahil tüm Kandıra genelinde hizmet sunuyoruz.' },
      { q: 'Kandıra\'da köy yollarında lastik tamiri yapılır mı?', a: 'Evet, mobil aracımız ile köy yollarında bile yerinde tamir yapıyoruz.' },
    ],
    nearbyDistricts: ['izmit-lastik-yol-yardim', 'basiskele-lastik-yol-yardim', 'karamursel-lastik-yol-yardim'],
    nearbyNames: ['İzmit', 'Başiskele', 'Karamürsel'],
  },
  {
    id: 12,
    slug: 'dilovasi-lastik-yol-yardim',
    name: 'Dilovası',
    displayName: 'Dilovası',
    mobileId: '12',
    title: 'Dilovası Lastik Yol Yardım | 7/24 Mobil Lastik Servisi',
    metaDesc: 'Dilovası lastik yol yardım. 7/24 acil lastik tamiri ve değişimi. Dilovası OSB, sanayi bölgesi ve merkeze mobil lastikçi.',
    h1: 'Dilovası Lastik Yol Yardım',
    h1Accent: 'Sanayi Bölgesinde 7/24',
    intro: 'Dilovası\'nda iş görüşmesine giderken aniden gelen bir ses ile günün kabusa dönmesin. 7/24 Lastik olarak Dilovası OSB, sanayi bölgeleri ve merkez mahallelere acil lastik yol yardım hizmeti sunuyoruz.',
    content: `<h2>Dilovası'nda Lastik Yol Yardım</h2>
<p><strong>Dilovası lastik yol yardım</strong> hizmetimiz, <strong>Dilovası Organize Sanayi Bölgesi (OSB)</strong>, kimya sanayi bölgesi ve çevre tüm alanlara 7/24 profesyonel destek sağlar.</p>

<h3>Dilovası'nda Neden 7/24 Lastik?</h3>
<ul>
<li>OSB ve sanayi bölgelerine özel hizmet</li>
<li>Ağır vasıta ve TIR lastik tamiri</li>
<li>TEM ve D-100 üzerinde hızlı erişim</li>
<li>Kimya sanayi bölgesi dahil tüm bölgeler</li>
</ul>

<p>Dilovası, yoğun sanayi trafiği nedeniyle lastik arızalarının en sık yaşandığı ilçelerden biridir. Ekibimiz bu bölgeye özel konumlanarak hızlı müdahale sağlar.</p>`,
    faqs: [
      { q: 'Dilovası OSB\'ye lastik servisi geliyor mu?', a: 'Evet, Dilovası Organize Sanayi Bölgesi dahil tüm Dilovası bölgelerine 7/24 hizmet veriyoruz.' },
      { q: 'Dilovası\'nda ağır vasıta lastik tamiri yapılıyor mu?', a: 'Evet, TIR, kamyon ve diğer ağır vasıta lastiklerine yerinde tamir ve değişim hizmeti sunuyoruz.' },
      { q: 'Dilovası\'nda gece lastik yol yardım var mı?', a: 'Evet, gece gündüz fark etmez. 7/24 Lastik ekibi her saat aktiftir.' },
    ],
    nearbyDistricts: ['gebze-lastik-yol-yardim', 'cayirova-lastik-yol-yardim', 'darica-lastik-yol-yardim'],
    nearbyNames: ['Gebze', 'Çayırova', 'Darıca'],
  },
  {
    id: 13,
    slug: 'hereke-lastik-yol-yardim',
    name: 'Hereke',
    displayName: 'Hereke',
    mobileId: '13',
    title: 'Hereke Lastik Yol Yardım | 7/24 Acil Lastik Tamiri Hereke',
    metaDesc: 'Hereke lastik yol yardım hizmeti. 7/24 acil lastik tamiri ve değişimi. Hereke, Körfez bölgesi ve çevre mahallelere hızlı müdahale.',
    h1: 'Hereke Lastik Yol Yardım',
    h1Accent: 'Hızlı Müdahale',
    intro: 'Hereke\'de her ne koşulda olursa olsun, 7/24 Lastik olarak herhangi bir arıza durumunda size sağlayacağımız lastik yol yardım hizmetleri ile yolunuza güvenle devam edin. Hereke merkez ve çevre bölgelerine hızla ulaşıyoruz.',
    content: `<h2>Hereke'de Lastik Yol Yardım</h2>
<p><strong>Hereke lastik yol yardım</strong> hizmetimiz ile Körfez ilçesine bağlı Hereke beldesinde sürücülere 7/24 destek sağlıyoruz. <strong>Hereke merkez</strong>, <strong>sahil yolu</strong> ve çevre mahallelere mobil lastik servisi sunuyoruz.</p>

<h3>Hereke'de Sunduğumuz Hizmetler</h3>
<ul>
<li>Acil lastik tamiri ve yaması</li>
<li>Lastik değişimi (binek ve ticari)</li>
<li>Sibop tamiri ve değişimi</li>
<li>Hava basma ve basınç kontrolü</li>
</ul>

<p>Hereke, Kocaeli'nin batı ucunda stratejik bir konumdadır. İstanbul-Kocaeli geçişinde lastik sorunu yaşayan sürücülere hızlı erişim sağlarız.</p>`,
    faqs: [
      { q: 'Hereke\'ye lastik yol yardım geliyor mu?', a: 'Evet, Hereke merkez ve çevre bölgelerine 7/24 lastik yol yardım hizmeti sunuyoruz.' },
      { q: 'Hereke\'de gece lastik tamiri yapılır mı?', a: 'Evet, gece gündüz 7/24 hizmet veriyoruz.' },
      { q: 'Hereke\'den İstanbul\'a giderken lastik patladı, yardım eder misiniz?', a: 'Evet, Hereke-İstanbul güzergahı kapsama alanımızdadır. Hemen arayın.' },
    ],
    nearbyDistricts: ['korfez-lastik-yol-yardim', 'gebze-lastik-yol-yardim', 'darica-lastik-yol-yardim'],
    nearbyNames: ['Körfez', 'Gebze', 'Darıca'],
  },
];

// Helper: slug ile ilçe bul
export const getDistrictBySlug = (slug) => DISTRICT_PAGES.find(d => d.slug === slug);

// Helper: mobil hizmet_detay ID → slug eşleme
export const MOBILE_DISTRICT_IDS = {};
DISTRICT_PAGES.forEach(d => { MOBILE_DISTRICT_IDS[d.mobileId] = `/${d.slug}`; });

// Tüm ilçe slug'ları (route oluşturma için)
export const ALL_DISTRICT_SLUGS = DISTRICT_PAGES.map(d => d.slug);
